import React, { type ReactNode } from 'react';
import { SkeletonText } from '@bynder/design-system';
import { OverviewCount as StyledOverviewCount } from '../Categories.styled';

type Props = {
    isLoading: boolean;
    children: ReactNode;
};

const OverviewCount = ({ isLoading, children }: Props) => (
    <StyledOverviewCount data-testid="overview count">{isLoading ? <SkeletonText /> : children}</StyledOverviewCount>
);

export default OverviewCount;
